var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcelFileBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9677 6.76406L15.8583 1.72031C15.7159 1.57969 15.5235 1.5 15.3217 1.5H5.23584C4.81559 1.5 4.47607 1.83516 4.47607 2.25V21.75C4.47607 22.1648 4.81559 22.5 5.23584 22.5H20.4312C20.8514 22.5 21.1909 22.1648 21.1909 21.75V7.29609C21.1909 7.09687 21.1102 6.90469 20.9677 6.76406ZM19.4387 7.64062H14.9703V3.22969L19.4387 7.64062ZM19.4814 20.8125H6.18555V3.1875H13.3558V8.25C13.3558 8.51107 13.4609 8.76145 13.6479 8.94606C13.8349 9.13066 14.0886 9.23438 14.353 9.23438H19.4814V20.8125ZM12.8834 13.5961L11.4161 11.1961C11.3638 11.1117 11.2712 11.0602 11.1715 11.0602H10.2598C10.2052 11.0602 10.1529 11.0742 10.1078 11.1047C9.97488 11.1867 9.93452 11.3602 10.02 11.4937L11.974 14.55L9.99387 17.6625C9.96697 17.7052 9.95211 17.7542 9.95082 17.8045C9.94954 17.8547 9.96189 17.9044 9.98658 17.9484C10.0113 17.9923 10.0474 18.029 10.0913 18.0546C10.1351 18.0801 10.1851 18.0937 10.236 18.0938H11.0552C11.1549 18.0938 11.2451 18.0422 11.2973 17.9602L12.786 15.5812L14.2652 17.9578C14.3174 18.0422 14.41 18.0914 14.5074 18.0914H15.3977C15.4523 18.0914 15.5045 18.075 15.552 18.0469C15.685 17.9625 15.723 17.7891 15.6375 17.6578L13.6431 14.6016L15.6684 11.4961C15.6958 11.4535 15.7111 11.4045 15.7128 11.3541C15.7145 11.3037 15.7025 11.2537 15.678 11.2095C15.6536 11.1652 15.6175 11.1282 15.5736 11.1024C15.5298 11.0765 15.4797 11.0628 15.4286 11.0625H14.581C14.4812 11.0625 14.3886 11.1141 14.3364 11.1984L12.8834 13.5961Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFileBig);
export default __webpack_public_path__ + "static/media/excel-file-big.6b30020592d562df3309160246d0976c.svg";
export { ForwardRef as ReactComponent };